import { CenteredFullScreenLayout } from '@/components/layout'

export default function NotFoundPage() {
  return (
    <CenteredFullScreenLayout>
      <div className="flex flex-col items-center space-y-4">
        <h1 className="text-6xl font-bold text-foreground">404</h1>
        <h2 className="text-2xl font-semibold text-foreground">Page Not Found</h2>
        <p className="text-lg text-center sm:w-xs text-muted-foreground">
          The page you are looking for does not exist.
        </p>
      </div>
    </CenteredFullScreenLayout>
  )
}
